/** Loan Information rows on commitment / loan-submission PDFs. Order matches the PDF layout. */
export const commitmentLetterFieldOptions: Record<string, string> = {
  noteRate: 'Note Rate',
  loanProgram: 'Loan Program',
  term: 'Term',
  initialLoanAmount: 'Initial Loan Amount',
  prepaymentPenalty: 'Prepayment Penalty',
  interestOnlyMonths: 'Interest Only Months',
  mortgageType: 'Mortgage Type',
  salesPriceValue: 'Sales Price/Value',
  loanPurpose: 'Loan Purpose',
  asIsAppraisedValue: 'As Is Appraised Value',
  lockExpDate: 'Lock Exp. Date',
  baseLoanAmount: 'Base Loan Amount',
  occupancy: 'Occupancy',
  totalLoanAmount: 'Total Loan Amount',
  trackRecord: 'Track Record',
  afterRepairValue: 'After Repair Value',
  constructionBudget: 'Construction Budget',
  constructionAmountFinanced: 'Construction Amount Financed',
  arvLtv: 'ARV-LTV',
  aivLtv: 'AIV-LTV',
  ltp: 'LTP',
  ltc: 'LTC',
}

export const defaultCommitmentLetterFields = Object.keys(commitmentLetterFieldOptions)

export const formDefaultsSubtabs = {
  ss89: 'SS-89',
  commitmentLetters: 'Commitment Letters',
}
